<div
  class="overlay-spinner overlay-spinner--size"
  *ngIf="isLoading"
  [id]="OVERLAY_SPINNER_ID"
  [tabIndex]="focusOnLoading ? 0 : -1"
  role="status"
  [attr.aria-label]="loadingAriaLabel | translate"
>
  <span class="loading-announcement" *ngIf="!focusOnLoading">{{ loadingAriaLabel | translate }}</span>
  <growth-report-cel-loader></growth-report-cel-loader>
</div>
<div class="content-container">
  <ng-content></ng-content>
</div>
